import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_update_stock_take_products: { message: "idle" },
};

export const tenant_update_stock_take_products_Slice = createSlice({
 name: "tenant_update_stock_take_products",
 initialState,
 reducers: {
  success_tenant_update_stock_take_products: (state, action) => {
   state.tenant_update_stock_take_products = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_update_stock_take_products: (state, action) => {
   state.tenant_update_stock_take_products = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_update_stock_take_products: (state) => {
   state.tenant_update_stock_take_products = { status: app_consts.IDLE };
  },
  loading_tenant_update_stock_take_products: (state) => {
   state.tenant_update_stock_take_products = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_update_stock_take_products, fail_tenant_update_stock_take_products, reset_tenant_update_stock_take_products, loading_tenant_update_stock_take_products } = tenant_update_stock_take_products_Slice.actions;

export default tenant_update_stock_take_products_Slice.reducer;